import React, { useEffect, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { getOptions } from "../../util/functions"

function withUrlOptions(WrappedComponent) {
    function OptionedComponent (props = {}) {
        const [options, setOptions] = useState(getOptions());
        
        const handleHashChange = useCallback(() => {
            const newOptions = getOptions()

            setOptions(newOptions)
        }, []);

        
        useEffect(() => {
            window.addEventListener('hashchange', handleHashChange);
            
            return () => {
                window.removeEventListener('hashchange', handleHashChange);
            };
        }, [handleHashChange]);
        
        const { darkMode, theme } = options

        return <WrappedComponent 
            {...options} 
            darkMode={!!theme ? theme === 'dark' : darkMode} 
            {...props} 
            />
    }

    OptionedComponent.propTypes = {
        fullView: PropTypes.bool,
        darkMode: PropTypes.bool,
        hidden: PropTypes.bool
    }

    return OptionedComponent
  }

  export default withUrlOptions